import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagLA = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M47.52 14.13C43.474 5.768 34.91 0 25 0 15.088 0 6.524 5.768 2.48 14.13L25 16.305l22.52-2.173ZM2.48 35.87C6.524 44.232 15.088 50 25 50c9.911 0 18.475-5.768 22.52-14.13L25 33.696 2.48 35.87Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M47.52 14.13H2.48A24.9 24.9 0 0 0 0 25a24.9 24.9 0 0 0 2.48 10.87h45.04A24.898 24.898 0 0 0 50 25a24.9 24.9 0 0 0-2.48-10.87Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 33.696a8.696 8.696 0 1 0 0-17.392 8.696 8.696 0 0 0 0 17.392Z"
}));
FlagLA.displayName = 'FlagLA';
export default withFlagWrapper(FlagLA);
//# sourceMappingURL=index.js.map